import createGetFormSyncWarnings from './selectors/getFormSyncWarnings';
import plain from './structure/plain';

export default createGetFormSyncWarnings(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/getFormSyncWarnings.js
// module id = 588
// module chunks = 0